let accessToken = null;
let session = null;

export const getAccessToken = () => accessToken;
export const getSession = () => session;

export const setAuthSession = (token, metadata = null) => {
  accessToken = token || null;
  session = metadata || null;
};

export const clearAuthSession = () => {
  accessToken = null;
  session = null;
};
